// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

function LargerGroupNote() {
  return (
    <MKBox component="section" py={3}>
      <Container>
        <MKBox
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          alignItems="center"
          gap={{ xs: 2, sm: 3 }}
          p={{ xs: 3, md: 3.5 }}
          borderRadius="lg"
          sx={({ palette: { info }, functions: { rgba } }) => ({
            backgroundColor: rgba(info.main, 0.08),
            border: "1px solid",
            borderColor: rgba(info.main, 0.2),
          })}
        >
          <MKBox
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              width: 52,
              height: 52,
              borderRadius: "50%",
              backgroundColor: "info.main",
              flexShrink: 0,
            }}
          >
            <Icon sx={{ color: "#fff", fontSize: "1.6rem !important" }}>groups</Icon>
          </MKBox>
          <MKBox flex={1} textAlign={{ xs: "center", sm: "left" }}>
            <MKTypography variant="h5" mb={0.5}>
              Traveling with a larger group?
            </MKTypography>
            <MKTypography variant="body2" color="text">
              More than 14 people? We can still cover your rental needs &mdash; get in touch and
              we&apos;ll help you find the right setup.
            </MKTypography>
          </MKBox>
          <MKButton
            variant="gradient"
            color="info"
            component={Link}
            to="/contact"
            sx={{ flexShrink: 0 }}
          >
            Get in touch
          </MKButton>
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default LargerGroupNote;
